<shared-app-header>
  <ng-content ngProjectAs="header-left">
    <orbit-button
      id="show-conversation-list-button"
      data-testid="btn-toggle-sidebar"
      [icon]="menuIcon"
      (click)="toggleConversationList.emit()"
      flat />
    <orbit-button
      id="dialog-button"
      class="hide-label-on-mobile-button"
      [label]="'SHARED.PAGES.DASHBOARD.CREATE_CONVERSATION_BUTTON' | translate"
      [icon]="createIcon"
      (click)="openCreateConversationDialog()" />
  </ng-content>
  <div ngProjectAs="header-right" class="header-actions">
    <orbit-button
      *ngIf="isOwner()"
      [label]="'SHARED.PAGES.DASHBOARD.SETTINGS_BUTTON' | translate"
      class="hide-label-on-mobile-button"
      [icon]="settingsIcon"
      (click)="navigateToSettings()" />
    <shared-avatar
      [name]="nameAbbreviation()"
      [size]="'small'"
      (avatarClicked)="openProfileOverlay($event)" />
  </div>
</shared-app-header>
